export class SQACode
{
    SQACode?: string;
    SQADescription?: string;
    SQACodeId?: number;
    isActiveFlag?: number;
    isWebFormActiveFlag?: number;
}